export default __webpack_public_path__ + "static/media/science.bbd36d7e.jpeg";